// *******************************************************
// DESCRIPTION: This jquery snippet will activate the iframe resizer on the resort detail page for TripAdvisor reviews
// *******************************************************
jQuery(function($) {

    $('#js-resort-reviews').each(function(index, el) {

        $('iframe').iFrameResize();
    });
});